module.exports = __webpack_public_path__ + "img/website.b3beef2a.png";